<script setup lang="ts">
import { faFilterCircleXmark } from '@fortawesome/pro-regular-svg-icons'

import { BtnIcon, BtnPrimary } from '@shared/ui/buttons'
import { MultiSelectSearchable } from '@shared/ui/fields'

import { useCustomerCommentsFilters } from '../../model/comments/customer-comments-filters.hook'

defineOptions({
  name: 'CustomerCommentsFilters',
})

const {
  refOptions,
  refInitialValue,
  isLoading,
  setSelected,
  submitSearch,
  clearFilters,
} = useCustomerCommentsFilters()
</script>

<template>
  <div class="customer-comments-filters">
    <MultiSelectSearchable
      :key="`disciplines-${refOptions.length}-${refInitialValue.join()}`"
      class="customer-comments-filters__disciplines"
      label="Disciplines"
      placeholder="All"
      :options="refOptions"
      :value="refInitialValue"
      is-all-available
      :disabled="isLoading"
      @selected="setSelected"
    />
    <BtnPrimary
      class="customer-comments-filters__button"
      text="Search"
      element-width="auto"
      :disabled="isLoading"
      @click="submitSearch"
    />
    <BtnIcon
      :icon="faFilterCircleXmark"
      color="red"
      tooltip-text="Clear filters"
      :disabled="isLoading"
      @click="clearFilters"
    />
  </div>
</template>

<style scoped lang="scss" src="./CustomerCommentsFilters.scss" />
